import SeoHead from "../components/SeoHead";
import { getSiteContent, localeRoutes } from "../i18n/siteContent";

function ServicesPage({ locale = "en" }) {
    const site = getSiteContent(locale);
    const text = site.services;
    const routes = localeRoutes[locale];
    const breadcrumbItems = [
        { name: site.nav.home, path: routes.home },
        { name: site.nav.services, path: routes.services }
    ];

    return (
        <>
            <SeoHead
                title={text.title}
                description={text.description}
                keywords="Maurizio Brioschi services, fractional cto services, solution architect consultant, cloud architect AWS, digital transformation consultant, architecture governance, delivery execution"
                path={routes.services}
                locale={locale}
                enPath={localeRoutes.en.services}
                itPath={localeRoutes.it.services}
                breadcrumbItems={breadcrumbItems}
            />
            <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
                <header>
                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-500">{text.label}</p>
                    <h1 className="mt-3 text-4xl font-impact text-slate-900">{text.heading}</h1>
                    <p className="mt-4 max-w-3xl text-slate-600">{text.intro}</p>
                </header>

                <section className="mt-8 grid gap-4">
                    {text.pillars.map((pillar) => (
                        <article key={pillar.title} className="rounded-2xl border border-slate-200 bg-white p-6">
                            <h2 className="text-2xl font-impact text-slate-900">{pillar.title}</h2>

                            <div className="mt-4">
                                <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">{text.symptomsLabel}</h3>
                                <ul className="mt-2 space-y-2 text-sm text-slate-700">
                                    {pillar.symptoms.map((item) => (
                                        <li key={item}>- {item}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="mt-4">
                                <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">{text.interventionLabel}</h3>
                                <p className="mt-2 text-sm text-slate-700">{pillar.intervention}</p>
                            </div>

                            <div className="mt-4">
                                <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">{text.outcomesLabel}</h3>
                                <ul className="mt-2 space-y-2 text-sm text-slate-700">
                                    {pillar.outcomes.map((item) => (
                                        <li key={item}>- {item}</li>
                                    ))}
                                </ul>
                            </div>
                        </article>
                    ))}
                </section>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-slate-900 p-6 text-white">
                    <h2 className="text-2xl font-impact">{text.engagementTitle}</h2>
                    <p className="mt-3 text-sm text-slate-200">{text.engagementBody}</p>
                    <a href={routes.contact} className="mt-5 inline-flex rounded-full bg-amber-500 px-5 py-3 text-sm font-semibold text-slate-900 transition hover:bg-amber-400">
                        {site.nav.cta}
                    </a>
                </section>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.internalLinksTitle}</h2>
                    <nav className="mt-4 grid gap-3 sm:grid-cols-2" aria-label={text.internalLinksTitle}>
                        {text.internalLinks.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                className="rounded-xl border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-800 transition hover:border-amber-300 hover:text-amber-700"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>
                </section>
            </main>
        </>
    );
}

export default ServicesPage;
